


































































































































































































































































































































import _ from 'lodash';
import { Component, Inject, Vue } from 'vue-property-decorator';
import { MuseClient } from 'muse-js';
import { EEGRelativePowerBand, POWER_BANDS, FrequencyBand } from 'muse-js';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { bufferCount, map } from 'rxjs/operators';
import Session from './Session.vue';
import Visualization from './Visualization.vue';
import ParticlesVisualization from './ParticlesVisualization.vue';
import FieldVisualization from './FieldVisualization.vue';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { saveAs } from 'file-saver';

import fontawesome from '@fortawesome/fontawesome';
import faBluetooth from '@fortawesome/fontawesome-free-brands/faBluetooth';
import faBluetoothB from '@fortawesome/fontawesome-free-brands/faBluetoothB';
import faPlayCircle from '@fortawesome/fontawesome-free-regular/faPlayCircle';
import faPauseCircle from '@fortawesome/fontawesome-free-regular/faPauseCircle';
import faCaretSquareDown from '@fortawesome/fontawesome-free-regular/faCaretSquareDown';
import faCaretSquareUp from '@fortawesome/fontawesome-free-regular/faCaretSquareUp';
import faPlay from '@fortawesome/fontawesome-free-solid/faPlay';
import faStop from '@fortawesome/fontawesome-free-solid/faStop';
import faChartLine from '@fortawesome/fontawesome-free-solid/faChartLine';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle';
import faSyncAlt from '@fortawesome/fontawesome-free-solid/faSyncAlt';
import faSlidersH from '@fortawesome/fontawesome-free-solid/faSlidersH';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';
import faCamera from '@fortawesome/fontawesome-free-solid/faCamera';

fontawesome.library.add(
  faBluetooth, faBluetoothB,
  faPlayCircle, faPauseCircle,
  faCaretSquareDown, faCaretSquareUp,
  faPlay, faStop,
  faChartLine, faInfoCircle, faSyncAlt, faSlidersH, faTimes, faCamera
);



export interface AveragedRelativeBandPowers {
  [index: string]: number;
}

@Component({
  components: {
    Session,
    Visualization,
    ParticlesVisualization,
    FieldVisualization,
    FontAwesomeIcon,
  }
})
export default class MuseRecorder extends Vue {
  private museClient: MuseClient;
  private connectionStatus: boolean = false;
  private sessionInProgress: boolean = false;
  private currentSessionSubscription: Subscription;
  private vizControlsDisplayed: boolean = false;
  private infoPanelOpened: boolean = false;
  private screenshotPanelOpened: boolean = false;
  private screenshotEmail: string = "";
  private screenshotSent: boolean = false;

  private currentSession: AveragedRelativeBandPowers[] = [];

  private alpha: number = 0;
  private beta1: number = 0;
  private beta2: number = 0;
  private beta3: number = 0;
  private gamma: number = 0;
  private n: number = 0;
  private paused: boolean = true;
  private sessionsDetailsOpened: boolean = false;

  private partyMode: boolean = true;
  private partyScales = {
    ALPHA: [.20, .33],
    BETA_1: [.15, .25],
    BETA_2: [.15, .25],
    BETA_3: [.15, .25],
    GAMMA: [.10, .20]
  }

  private created() {
    this.museClient = new MuseClient();
  }

  private async connectToMuse() {
    if (!this.connectionStatus) {
      await this.museClient.connect();
      await this.museClient.start();
      this.museClient.connectionStatus.subscribe(
        cS => this.connectionStatus = cS
      );
    }

    this.startSession();
  }

  private startSession() {
    function clamp (v) {
      return Math.max(Math.min(1, v), 0);
    }

    this.currentSession = [];
    if (this.currentSessionSubscription) {
      this.currentSessionSubscription.unsubscribe();
    }

    // @ts-ignore
    this.currentSessionSubscription = (this.museClient.relativeBandPowers as Observable<EEGRelativePowerBand[]>)
      .pipe(
        bufferCount(100, 25)
      ,
        map( (sessions: EEGRelativePowerBand[][]): EEGRelativePowerBand[] =>
          Object.keys(POWER_BANDS).map( (k): EEGRelativePowerBand => {
            return {
              band: POWER_BANDS[k],
              power: sessions.map(
                  (session: EEGRelativePowerBand[]): number => {
                    let bandSession = session.find( r => r.band.id == POWER_BANDS[k].id );
                    if (bandSession) {
                      return bandSession.power;
                    } else {
                      return NaN;
                    }
                  }
                ).reduce(
                  ((sumOfSessions, bandSessionValue) =>
                    sumOfSessions += bandSessionValue
                  ), 0
                ) / sessions.length
            };
          })
        )
      ,
        map( (rbps: EEGRelativePowerBand[]): AveragedRelativeBandPowers => {
          let arbps: AveragedRelativeBandPowers = {};
          rbps.forEach( (rbp) => arbps[rbp.band.id] = rbp.power );
          return arbps;
        })
      ).subscribe(
        (arbps: AveragedRelativeBandPowers) => {
          if ( _.some(arbps, v => _.isNaN(v) ) )
            return;
          this.currentSession.push(Object.freeze(arbps));
          this.currentSession = _.takeRight(this.currentSession, 100);
          this.n = Math.min(this.currentSession.length * 5, 100);

          if (this.partyMode) {
            this.alpha = clamp(
              ( arbps.ALPHA - this.partyScales.ALPHA[0] ) / ( this.partyScales.ALPHA[1] - this.partyScales.ALPHA[0])
            );
            this.beta1 = clamp(
              ( arbps.BETA_1 - this.partyScales.BETA_1[0] ) / ( this.partyScales.BETA_1[1] - this.partyScales.BETA_1[0])
            );
            this.beta2 = clamp(
              ( arbps.BETA_2 - this.partyScales.BETA_2[0] ) / ( this.partyScales.BETA_2[1] - this.partyScales.BETA_2[0])
            );
            this.beta3 = clamp(
              ( arbps.BETA_3 - this.partyScales.BETA_3[0] ) / ( this.partyScales.BETA_3[1] - this.partyScales.BETA_3[0])
            );
            this.gamma = clamp(
              ( arbps.GAMMA - this.partyScales.GAMMA[0] ) / ( this.partyScales.GAMMA[1] - this.partyScales.GAMMA[0])
            );
          } else {
            this.alpha = (
              arbps.ALPHA - Math.min(...this.currentSession.map( d => d.ALPHA ))
            ) / (
              Math.max(...this.currentSession.map( d => d.ALPHA )) - Math.min(...this.currentSession.map( d => d.ALPHA ))
            );
            this.gamma = (
              arbps.GAMMA - Math.min(...this.currentSession.map( d => d.GAMMA ))
            ) / (
              Math.max(...this.currentSession.map( d => d.GAMMA )) - Math.min(...this.currentSession.map( d => d.GAMMA ))
            );
            this.beta1 = (
              arbps.BETA_1 - Math.min(...this.currentSession.map( d => d.BETA_1 ))
            ) / (
              Math.max(...this.currentSession.map( d => d.BETA_1 )) - Math.min(...this.currentSession.map( d => d.BETA_1 ))
            );
            this.beta2 = (
              arbps.BETA_2 - Math.min(...this.currentSession.map( d => d.BETA_2 ))
            ) / (
              Math.max(...this.currentSession.map( d => d.BETA_2 )) - Math.min(...this.currentSession.map( d => d.BETA_2 ))
            );
            this.beta3 = (
              arbps.BETA_3 - Math.min(...this.currentSession.map( d => d.BETA_3 ))
            ) / (
              Math.max(...this.currentSession.map( d => d.BETA_3 )) - Math.min(...this.currentSession.map( d => d.BETA_3 ))
            );
          }
        }
      );
    this.sessionInProgress = true;
    this.paused = false;
  }

  private toggleScreenshotPanel () {
    this.screenshotEmail = '';
    this.screenshotSent = false;
    this.screenshotPanelOpened = !this.screenshotPanelOpened;
  }

  private stopSession() {
    if (this.currentSessionSubscription) {
      this.currentSessionSubscription.unsubscribe();
    }
    this.sessionInProgress = false;
    this.paused = true;
    this.n = 0;
  }

  private toggleVizControlsDisplayed() {
    this.vizControlsDisplayed = !this.vizControlsDisplayed;
  }

  private reload() {
    window.location.reload();
  }

  private saveScreenshot() {
    let canvas = this.$el.querySelector('canvas');
    if (!canvas) { return }

    canvas.toBlob( (blob) => {
      if (!blob) { return }
      saveAs(blob, `${this.screenshotEmail || 'anonymous'}-${Date().toString()}.png`);
      this.screenshotSent = true;
      this.screenshotEmail = '';

      setTimeout( () => {
        this.screenshotPanelOpened = false
      }, 6000)

    });
  }

  private beforeDestroy() {
    this.stopSession();
  }
}
